import d from "./index4.js";
import { resolveComponent as l, openBlock as c, createElementBlock as m, createElementVNode as e, renderSlot as a, createVNode as n, withModifiers as p, withCtx as i, pushScopeId as b, popScopeId as u } from "vue";
import "./index5.js";
import v from "../../../../_virtual/index.js";
const _ = (t) => (b("data-v-ab54e6cb"), t = t(), u(), t), f = {
  id: "base-prompt-id",
  class: "base-prompt"
}, h = /* @__PURE__ */ _(() => /* @__PURE__ */ e("div", { class: "base-prompt-hat" }, null, -1)), C = {
  id: "base-prompt-content",
  class: "base-prompt-container"
}, $ = { class: "base-prompt-question" }, k = { class: "base-prompt-buttons-container" };
function I(t, o, S, q, V, w) {
  const r = l("sequiter-button");
  return c(), m("div", f, [
    h,
    e("div", C, [
      e("span", $, [
        a(t.$slots, "base-prompt-question", {}, void 0, !0)
      ]),
      e("div", k, [
        n(r, {
          class: "base-prompt-yes",
          variant: t.buttonVariants.PRIMARY,
          onClick: o[0] || (o[0] = p((s) => t.yesClicked(s), ["prevent"]))
        }, {
          default: i(() => [
            a(t.$slots, "base-prompt-yes-label", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["variant"]),
        n(r, {
          class: "base-prompt-no",
          variant: t.buttonVariants.SECONDARY,
          onClick: o[1] || (o[1] = p((s) => t.noClicked(s), ["prevent"]))
        }, {
          default: i(() => [
            a(t.$slots, "base-prompt-no-label", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["variant"])
      ])
    ])
  ]);
}
const R = /* @__PURE__ */ v(d, [["render", I], ["__scopeId", "data-v-ab54e6cb"]]);
export {
  R as default
};
//# sourceMappingURL=index3.js.map
